import { Component, Input } from '@angular/core';
import { SuggestionProps } from '@tiptap/suggestion';
import uuid from 'short-unique-id';
import { addTag } from './add-tags';
import { ItemSelectionComponent } from '../item-selection';

@Component({
  selector: 'app-mention',
  templateUrl: './mention.component.html',
  styleUrl: './mention.component.scss',
})

export class MentionComponent extends ItemSelectionComponent{
  @Input()
  set _props(value: SuggestionProps){
    this.props = value;
    this.setItems(this.props.items);
  }
  get _props() {
    return this.props;
  }

  private uuid = new uuid({ length: 6, dictionary: 'number' });
  constructor(){
    super();
  }
  public props:SuggestionProps;

  selectItem(index: number) {
    const item = this.props.items[index];
    const uuid = this.uuid();
    Object.assign(item, { id: uuid, uud: uuid });
    if (item) {
      this.props.command(item);
    }
    addTag(item, this.props.editor);
  }

  onKeyDown({ event }) {
    if (event.key === 'ArrowUp') {
      this.upHandler();
      return true;
    }

    if (event.key === 'ArrowDown') {
      this.downHandler();
      return true;
    }

    if (event.key === 'Enter') {
      this.enterHandler();
      return true;
    }

    return false;
  }
}
